module.exports = __webpack_public_path__ + "media/images/arrow-button-9485ef2f80896eb9b9160a455efd3015.svg";